export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_GUIDES":
      return action.payload;
    case "UPDATE_GUIDE":
      return state.map((item) => {
        if (item.id !== action.payload.id) {
          return item;
        }
        return { ...item, ...action.payload };
      });
    case "REMOVE_GUIDE":
      return state.filter((item) => item.id !== action.payload);
    case "ADD_GUIDE":
      return [...state, action.payload];
    default:
      return state;
  }
};
